import React from 'react';
import PropTypes from 'prop-types';
import DeliveryEstimation from '../shipping_fees/delivery_estimation';
import ShippingImage from '../shipping_fees/shipping_image';
// import ShippingCost from '../shipping_fees/shipping_cost';
import { showAction } from '../../../actions/catalog_postcode_actions';
import Translation from '../../translation/translation';
import { show as showDeliveryInfo } from '../../../../_flux/actions/catalog_delivery_info_light_box_actions';

const openPostcode = () => {
  return showAction();
};

const ShippingFees = (props) => {
  let { shippingData, productSku, stock, currencyIsoCode, staticImagesUrl, productType } = props;

  let data = shippingData.filter((item) => (item.statusCode === 200 ? item : null));

  let renderData = data.map((item) => {
    const { daysTo } = item.body.shippingOptions[0].shippingTime;
    const { amount } = item.body.shippingOptions[0];
    const { state } = item.body.stockLocation;
    const shippingPostcode = item.body.addressShipping.postcode;

    if (item.id.value !== productSku) {
      return null;
    }

    return (
      <>
        {amount === 0 && (
          <div
            className="product-tile__free-shipping-metro-area align-items-center"
            key={`free-shipping-${productSku}`}
          >
            <ShippingImage staticImagesUrl={staticImagesUrl} daysTo={daysTo} />
            <Translation
              tagName="span"
              className="shipping-fees__cost-free-shipping"
              translationKey="navigation-level-2-deals-free-shipping-icon-alt"
              onClick={openDetailLightBox}
            />

            {!props.isSponsoredProduct && (
              <Translation
                tagName="span"
                className="shipping-fees__learn-more"
                style={{ color: '#3D83E1' }}
                translationKey="product-revamp-shipping-delivery-learn-more"
                onClick={openDetailLightBox}
              />
            )}
          </div>
        )}
        <div className="shipping-fees" key={productSku}>
          <ShippingImage staticImagesUrl={staticImagesUrl} daysTo={daysTo} />
          <div className="shipping-fees__label">
            <DeliveryEstimation
              productType={productType}
              daysTo={daysTo}
              state={state}
              amount={amount}
              stock={stock}
              currencyIsoCode={currencyIsoCode}
              postcode={shippingPostcode}
              openPostcode={openPostcode}
            />
          </div>
        </div>
      </>
    );
  });

  return renderData;
};

const openDetailLightBox = () => {
  return showDeliveryInfo(true);
};

ShippingFees.propTypes = {
  shippingData: PropTypes.array.isRequired,
  productSku: PropTypes.string.isRequired,
  promotion: PropTypes.object,
  stock: PropTypes.number.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  staticImagesUrl: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
};

export default ShippingFees;
